import * as React from 'react';
import './AccordionsGroup.scss';
import { Paper } from '@mui/material';
import { IAccordionsGroupProps } from './IAccordionsGroup';
import { IAccordionProps } from '../Accordion/IAccordion';
import _uniqueId from 'lodash/uniqueId';
import { useState } from 'react';

const AccordionsGroup = (props: IAccordionsGroupProps) => {
    const [id] = useState(_uniqueId('prefix-'));
    return (
        <Paper style={{maxHeight: "calc(100vh - 210px)", overflow: 'auto'}}>
            <div className='accordion' id={`accordionGroup${id}`}>
                {props.items.map((item: IAccordionProps, index: Number) => {
                    let target = `target_${item.title.replace(/\W/g,'_')}_${index}`;
                    let labelledBy = `labelledBy_${item.title.replace(/\W/g,'_')}_${index}`;
                    return (
                        <div className='accordion-item' key={target}>
                            <h2 className='accordion-header' id={labelledBy}>
                                <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target={`#${target}`} aria-expanded='true' aria-controls={target}>
                                    {item.title}
                                </button>
                            </h2>
                            <div id={target} className='accordion-collapse collapse' aria-labelledby={labelledBy} data-bs-parent={`#accordionGroup${id}`}>
                                <div className='accordion-body'>{item.children}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Paper>
    );
};

export default AccordionsGroup;
